export const SET_ACCOUNTS = "SET_ACCOUNTS";
export type SET_ACCOUNTS = typeof SET_ACCOUNTS;

export const SET_IS_LOADING_ACCOUNTS = "SET_IS_LOADING_ACCOUNTS";
export type SET_IS_LOADING_ACCOUNTS = typeof SET_IS_LOADING_ACCOUNTS;
